var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66699 11.8841C1.66699 6.42526 6.09225 2 11.5511 2C15.6428 2 19.1538 4.48625 20.6558 8.03043C20.8962 8.59778 20.4511 9.18842 19.8349 9.18842C19.4411 9.18842 19.0949 8.93782 18.9338 8.57855C17.67 5.76022 14.8398 3.79711 11.5511 3.79711C7.08476 3.79711 3.4641 7.41777 3.4641 11.8841C3.4641 15.4766 5.80662 18.522 9.04752 19.5761C9.45512 19.7087 9.75393 20.0749 9.75393 20.5035C9.75393 21.0768 9.23212 21.5118 8.68344 21.3458C4.62305 20.1168 1.66699 16.3456 1.66699 11.8841ZM20.3842 11.9915C20.2132 12.0623 20.0577 12.1662 19.9268 12.2971L19.1794 13.0445L21.1733 15.0385L21.9207 14.291C22.0517 14.1601 22.1555 14.0047 22.2264 13.8336C22.2972 13.6625 22.3337 13.4792 22.3337 13.2941C22.3337 13.1089 22.2972 12.9256 22.2264 12.7545C22.1555 12.5834 22.0517 12.428 21.9207 12.2971C21.7898 12.1662 21.6344 12.0623 21.4633 11.9915C21.2923 11.9206 21.1089 11.8841 20.9238 11.8841C20.7386 11.8841 20.5553 11.9206 20.3842 11.9915ZM20.0968 16.115L18.1028 14.1211L13.1973 19.0266L12.6657 20.976C12.5701 21.3263 12.8915 21.6477 13.2418 21.5522L15.1912 21.0205L20.0968 16.115ZM11.5511 5.59423C12.0473 5.59423 12.4496 5.99653 12.4496 6.49279V11.3288L14.7434 12.4757C15.1873 12.6976 15.3672 13.2374 15.1453 13.6812C14.9233 14.1251 14.3836 14.305 13.9397 14.0831L11.1492 12.6878C10.8448 12.5356 10.6525 12.2245 10.6525 11.8841V6.49279C10.6525 5.99653 11.0548 5.59423 11.5511 5.59423Z",
    fill: "url(#paint0_linear_4463_5626)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4463_5626",
    x1: 9.99176,
    y1: 21.5692,
    x2: 13.6072,
    y2: 1.92606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44A1FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTime);
export default __webpack_public_path__ + "static/media/EditTime.3a0040c2d98a8f302c119489a284ea6b.svg";
export { ForwardRef as ReactComponent };